export default function SmokeAlarmIcon({
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M11.63 12.84v-1.5a.38.38 0 1 1 .74 0v1.5a.37.37 0 0 1-.74 0Zm1.69-.12.39-1.45a.37.37 0 0 1 .72.2l-.39 1.44a.37.37 0 0 1-.72-.19Zm1.73-.16.75-1.3a.38.38 0 0 1 .65.37l-.75 1.3a.37.37 0 0 1-.65-.37Zm-6.75.37-.75-1.3a.38.38 0 0 1 .65-.37l.75 1.3a.37.37 0 0 1-.65.37Zm1.66-.02-.4-1.44a.38.38 0 0 1 .73-.2l.4 1.45a.37.37 0 0 1-.73.2Zm-1.21 6.18c1.18-.73.8-1.04.34-1.46-1.05-.95-.71-1.74.53-2.31a.37.37 0 0 1 .32.68c-1.07.49-.75.71-.34 1.08 1.1 1 .82 1.86-.46 2.65a.38.38 0 0 1-.4-.64Zm2.62 0c1.18-.73.81-1.04.35-1.46-1.06-.95-.72-1.74.53-2.31a.37.37 0 0 1 .31.68c-1.06.49-.74.71-.34 1.08 1.11 1 .82 1.86-.45 2.65a.38.38 0 0 1-.4-.64Zm2.63 0c1.18-.73.8-1.04.34-1.46-1.05-.95-.71-1.74.53-2.31a.37.37 0 0 1 .32.68c-1.07.49-.75.71-.34 1.08 1.1 1 .82 1.86-.46 2.65a.38.38 0 0 1-.4-.64Z"
      />
      <path
        fill="currentColor"
        d="M20.58 4.22H3.42A1.13 1.13 0 0 0 2.3 5.34V9.1a1.13 1.13 0 0 0 1.12 1.13h.51l2.57 3.65a1.59 1.59 0 0 0 1.3.61h8.4a1.59 1.59 0 0 0 1.3-.6l2.57-3.66h.5A1.13 1.13 0 0 0 21.7 9.1V5.34a1.13 1.13 0 0 0-1.12-1.12Zm-17.16.75h17.16a.38.38 0 0 1 .37.37v.38H3.05v-.38a.38.38 0 0 1 .37-.37Zm13.47 8.47a.85.85 0 0 1-.69.3H7.8a.85.85 0 0 1-.69-.3l-2.26-3.22h14.3l-2.26 3.22Zm3.69-3.97H3.42a.38.38 0 0 1-.37-.38V6.47h17.9v2.62a.37.37 0 0 1-.37.38Z"
      />
    </svg>
  );
}
